import React from 'react';
import './Header.css';

const Header =() => {
    return(
        <div className='header'>
            <div className='header-contents'>
                <h2>Order your favourite food here</h2>
                <p>Food is an essential aspect of our daily lives. Not only does it provide us with the necessary nutrients to sustain our bodies, but it also plays a significant role in our culture, traditions, and social gatherings. In this article, we will explore the various facets of food and its importance in shaping our lives.</p>
                <button>View Menu</button>
            </div>
            
        </div>
        )
}
export default Header;
